import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import { instance } from "Actions/AxiosInstance";
import { CheckActionPermission } from "Actions/commonAction";
import empty from "Assets/Svg/recruit-no-requistion.svg";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import DrawerHeader from "Component/Headers/drawerHeader";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import Create from "./create";
import CustomLoader from "Component/CustomLoader";

let shouldCallAPI = true;

const POST_DATA = {
  savedresponseid: null,
  title: "",
  responsebodypath: null,
  bodyvariableids: [],
  ticketcategoryids: null,
};

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modules: {
        toolbar: {
          container: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike"],
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
            // [{ placeholder: [] }],
          ],
          // handlers: {
          //   placeholder(value) {
          //     console.log("this: ", this);
          //     const obj = global.find((x) => x.displayname == value);
          //     if (value) {
          //       const cursorPosition = this.quill.getSelection().index;
          //       this.quill.insertText(cursorPosition, `{${obj.variablevalue}}`);
          //       this.quill.setSelection(
          //         cursorPosition + obj.variablevalue.length + 2,
          //       );
          //     }
          //   },
          // },
        },
      },
      allemployees: [],
      permissions: { editable: true, readonly: true },
      listdata: [],
      offset: 0,
      limit: 10,
      active: 0,
      fullcount: 1,
      activeticket: 1,
      ticketCategoryList: [],
      value: 0,
      data: false,
      postData: null,
      copypolicy: null,
      nofuel: false,
      selectedRow: null,
      selectedticketcategoryid: [],
      ishiringmanager: false,
      right: false,
      ispipeline: false,
      open: false,
      newpolicycreate: false,
      headers: [
        {
          key: "title",
          name: "Response title",
          style: { textAlign: "left" },
          type: TDTypeConsts.COMMONNAME,
        },
        {
          key: "responsebodypath",
          name: "Response message",
          style: { textAlign: "left" },
          type: TDTypeConsts.CONVERSATION,
        },
        {
          key: "ticketcategory",
          name: "Categories linked",
          style: { textAlign: "left" },
          type: TDTypeConsts.ASSIGNED_OWNERS,
        },

        {
          key: "status",
          name: "Status",
          type: TDTypeConsts.STATE_ACTIVE_INACTIVE,
        },
        {
          key: "",
          name: "",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };

    this.getAllSavedResponse = this.getAllSavedResponse.bind(this);
    this.renderList = this.renderList.bind(this);
    this.renderCreate = this.renderCreate.bind(this);
    this.onCreate = this.onCreate.bind(this);
    this.onEdit = this.onEdit.bind(this);
    // this.onDelete = this.onDelete.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.searchResponse = this.searchResponse.bind(this);
    // this.updatePostData = this.updatePostData.bind(this);
    this.toggleAssginedOwnerDrawer = this.toggleAssginedOwnerDrawer.bind(this);
    this.getLetterVariables = this.getLetterVariables.bind(this);
    this.getTicketCategoryList = this.getTicketCategoryList.bind(this);
    this.handleScroll1 = this.handleScroll1.bind(this);
  }

  toggleAssginedOwnerDrawer(e, row) {
    instance
      .post(`helpdesk/getlinkresponsecategory`, {
        ticketcategoryids: row.ticketcategoryids,
      })
      .then((resp) => {
        this.setState({
          arrTicketCategory: resp.data.result,
          drawerOpen: true,
        });
      });
  }

  searchResponse(e) {
    const { backupList, listdata } = this.state;
    const filterList = listdata.filter(
      (item) =>
        item.title.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      listdata: e.target.value ? filterList : backupList,
      isdata: filterList.length == 0 ? true : false,
    });
  }

  getLetterVariables() {
    instance
      .get("superuser/getlettervariablelist/6")
      .then((result) => {
        const { modules } = this.state;
        modules.toolbar.container[6][0].placeholder = result.data.result
          .filter((x) => !x.iscustom && x.displayvalue != 999)
          .map((x) => x.displayname);
        console.log(
          "modules.toolbar.container[6][0].placeholder: ",
          modules.toolbar.container[6][0].placeholder,
        );
        this.setState(
          {
            letterVariables:
              result.data.result.filter((x) => !x.iscustom) || [],
            modules,
          },
          () => {
            console.log("modules: ", modules);
            global = this.state.letterVariables;
          },
        );
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onStateStatusChange = (value, selectedRow) => {
    const data = {
      savedresponseid: selectedRow.savedresponseid
        ? selectedRow.savedresponseid
        : null,
      status: value == 1 ? true : false,
    };
    instance.post("helpdesk/changeresponsestatus", data).then((res) => {
      this.setState(
        {
          isactive: res.data.result,
          offset: 0,
          fullcount: 1,
        },
        () => this.getAllSavedResponse(true),
      );
    });
  };

  componentWillMount() {
    if (this.props.history.location.pathname.includes("create")) {
      this.props.history.push(`${this.props.match.path}/list`);
    }
  }

  handleScroll1() {
    const windowBottom =
      Math.floor(window.innerHeight * 0.65) + window.pageYOffset;
    if (windowBottom >= Math.floor(window.innerHeight * 0.65)) {
      if (this.state.fullcount > this.state.offset) {
        this.getAllSavedResponse(false);

        setTimeout(() => {
          shouldCallAPI = true;
        }, 2000);
      }
    }
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("cannedResponses");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getAllSavedResponse(false);
        this.getTicketCategoryList();
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.MORE_OPTIONS,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
      });

      if (this.props.history.location.pathname.includes("create")) {
        this.props.history.push(`${this.props.match.path}`);
      }
    } else {
      this.setState({ permissiondenied: true });
    }
    // this.getAllSavedResponse(false);

    window.addEventListener("scroll", this.handleScroll1);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll1);
  }

  getTicketCategoryList() {
    instance
      .get(`helpdesk/getticketcategorylist/${this.state.activeticket}`)
      .then((resp) => {
        this.setState({
          ticketCategoryList: resp.data.result,
          data: true,
          // backupList: resp.data.result,
        });
      });
  }

  getAllSavedResponse(isRefresh = false) {
    const { listdata } = this.state;
    if (isRefresh) {
      this.setState({
        fullcount:
          this.state.listdata.length == 0
            ? 1
            : this.state.listdata[0].fullcount,
        offset: this.state.listdata.length == 0 ? 0 : this.state.offset,
      });
    }
    if (shouldCallAPI) {
      if (this.state.offset < this.state.fullcount) {
        shouldCallAPI = false;
        this.setState({isLoading: true}, () => {
        instance
          .get(
            `helpdesk/getallsavedresponse/${this.state.limit}/${this.state.offset}/${this.state.active}`,
          )
          .then((resp) => {
            let list = [];
            shouldCallAPI = true;
            isRefresh
              ? (list = [...resp.data.result])
              : (list = [...listdata, ...resp.data.result]);
            this.setState({
              listdata: list,
              data: true,
              backupList: resp.data.result,
              fullcount: resp.data.result[0]
                ? parseInt(resp.data.result[0].fullcount)
                : 1,
              offset: this.state.offset + this.state.limit,
              isLoading:false
            });
          });
        })
      }
    }
  }

  // updatePostData(postData) {
  //   this.setState({ postData });
  // }

  onCreate() {
    this.setState(
      {
        postData: {
          savedresponseid: null,
          title: "",
          responsebodypath: null,
          bodyvariableids: [],
          ticketcategoryids: null,
        },
        fullcount:
          this.state.listdata && this.state.listdata.length == 0 ? 1 : "",
        offset: 0,
      },
      () => {
        this.props.history.push(`${this.props.match.url}/create`);
      },
    );
  }

  onEdit() {
    const { selectedRow } = this.state;

    this.setState(
      { postData: selectedRow, createmenu: false, offset: 0, fullcount: "" },
      () => {
        this.props.history.push(`${this.props.match.url}/create`);
      },
    );
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  renderCreate() {
    return (
      <Create
        {...this.props}
        {...this.state}
        onCreate={true}
        // updatePostData={this.updatePostData}
        getAllSavedResponse={this.getAllSavedResponse}
        // getAllEmp={this.getAllEmp}
      />
    );
  }

  renderList() {
    return (
      <div className="content-outer-wrapper" onScroll={this.handleScroll1}>
        {this.state.isLoading ?
<CustomLoader/>

:<div>
        {this.state.listdata && this.state.listdata.length > 0 ? (
          <div>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} sm={12}>
                <p className="large-text-dark-secondary margin-bottom-24 t-bold">
                  Canned Response
                </p>
              </Grid>
              <Grid
                item
                md={8}
                sm={12}
                justify="flex-end"
                className="display-flex"
              >
                <div>
                  {/* <div className="floatleft margin-right-16">
                    <SearchRound
                      placeholder="Search"
                      value={this.state.searchValue}
                      onChange={this.searchResponse}
                    />
                  </div> */}

                  {/* {this.state.permissions.editable && ( */}
                  {/* {this.state.listdata.length > 0 && (
                    <span className="floatleft">
                      <Button
                        variant="contained"
                        className="btn btn-primary-md-blue"
                        color="primary"
                        onClick={this.onCreate}
                      >
                        Create new
                      </Button>
                    </span>
                  )} */}
                  {/* )} */}

                  {/* {this.state.listdata.length == 0 && this.state.searchValue && (
                    <span className="floatleft">
                      <Button
                        variant="contained"
                        className="btn btn-primary-md-blue"
                        color="primary"
                        onClick={this.onCreate}
                      >
                        Create new
                      </Button>
                    </span>
                  )} */}
                </div>
              </Grid>
            </Grid>
            <List
              // showOnlyList
              list={this.state.listdata}
              permissions={this.state.permissions}
              headers={this.state.headers}
              onCreate={this.onCreate}
              onEdit={this.onEdit}
              onStateStatusChange={this.onStateStatusChange}
              onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
              toggleAssginedOwnerDrawer={(e, row) =>
                this.toggleAssginedOwnerDrawer(e, row)
              }
              module="Canned response"
            />
            <Popover
              open={this.state.createmenu}
              anchorEl={this.state.create_anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => this.setState({ createmenu: false })}
              className="margin-top-8"
            >
              <Paper style={{ width: 190 }}>
                <div>
                  <MenuListComponent>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onEdit}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Edit</span>
                      </ListItemText>
                    </ListItem>
                    {/* <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={this.onDelete}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span className="small-dark-secondary">Delete</span>
                      </ListItemText>
                    </ListItem> */}
                  </MenuListComponent>
                </div>
              </Paper>
            </Popover>
            <Drawer
              anchor="right"
              open={this.state.drawerOpen}
              onClose={() =>
                this.setState({
                  drawerOpen: false,
                  arrTicketCategory: [],
                })
              }
              classes={{ paper: "width30 padding16" }}
            >
              <DrawerHeader
                header="Categories linked"
                isbackarrow={false}
                closeDrawer={() =>
                  this.setState({
                    drawerOpen: false,
                    arrTicketCategory: [],
                  })
                }
              />
              <ol className="margin-top-0">
                {this.state.arrTicketCategory &&
                  this.state.arrTicketCategory.map((owner) => (
                    <li className="normal-dark" style={{ padding: "8px 0px" }}>
                      {owner.displayname}
                    </li>
                  ))}
              </ol>
            </Drawer>
          </div>
        ) : (
          <div className="position-rel">
            <DefaultComp
              heading="There are no canned responses to display"
              subheading="Get started by creating your first canned response!"
              imageSrc={empty}
            />
            {this.state.permissions.editable && (
              <div className="text-center margin-top-24">
                <Button
                  className="btn btn-primary-md-blue"
                  variant="contained"
                  onClick={this.onCreate}
                >
                  Create new
                </Button>
              </div>
            )}
          </div>
        )}
        </div>
        }
      </div>
    );
  }

  render() {
    const { match } = this.props;
    return (
      <div>
        <IntlProvider locale="en">
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <div>
              {/* {this.state.data && ( */}
                <div>
                  <div>
                    <Switch>
                      <Route
                        exact
                        path={`${match.path}`}
                        render={this.renderList}
                      />
                      <Route
                        exact
                        path={`${match.path}/create`}
                        render={this.renderCreate}
                      />
                      <Redirect from={`${match.path}`} to={`${match.path}`} />
                    </Switch>
                  </div>
                </div>
              {/* )} */}
            </div>
          )}
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  SubscriptionInfo: state.SubscriptionInfo,
  loginData: state.AuthenticationAction.login,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withSnackbar(index)),
);
